/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#cashback-tipo[_ngcontent-%COMP%]{display:inline-table}#cashback-tipo[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{margin-right:5px}"];
export { styles as styles };
